import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { useParams, useHistory, Link } from "react-router-dom";
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { ROLENAME } from '../utils';
import Dialog from '@material-ui/core/Dialog';
import { Tooltip } from 'antd';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import HttpService from '../services/httpService';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Checkbox from '@material-ui/core/Checkbox';
import { commaSeparateAmount } from './commaSeparate';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
    table: {
        width: '80vw',
        textAlign: 'center'
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}));


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ccc",
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function DesignQuoteApprovalPage(props) {
    const classes = useStyles()
    const { userDetails } = useSelector(state => state.user);
    const history = useHistory();
    const [commonExpCenter, setExpCenter] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [approvalData, setApprovalData] = useState([]);
    const [remark, setRemark] = useState('');
    const [approvalType, setApprovalType] = useState('')
    const [rowData, setRowData] = useState()
 
    useEffect(() => {
        getAllApprovedLeads();
        expCenters();
    }, [])

    const getAllApprovedLeads = async () => {
        props.setLoading(true)
        try {
            let obj = {
                commonExpCenter
            }
            let res = await HttpService.getDesignQuoteApprovalData(obj);
            if (res.status === 200) {
                setApprovalData(res.data);
            }
        } catch (error) {
            console.error(error);
            props.setSnackInfo("Something went wrong", "error")
        }
        props.setLoading(false)
    }


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const handleApprove = (row)=>{
        setOpenDialog(true);
        setApprovalType('Approved');
        setRowData(row);
    }

    const handleReject = (row)=>{
        setOpenDialog(true);
        setApprovalType('Rejected')
        setRowData(row);

    }
    
    const handleApprovalDesignQuote = async()=>{
        try{
            setOpenDialog(false);
            let obj = {
                remark,
                approvalType,
                leadId: rowData?._id,
                reductionValueLessThan10More20: rowData?.designQuoteApproval?.reductionValueLessThan10More20,
                reductionValueMoreThan20: rowData?.designQuoteApproval?.reductionValueMoreThan20
            }
            let res = await HttpService.approveRejectDesignQuote(obj);
            if(res.status === 200){
                props.setSnackInfo(`${res.data.type} Successfully`, 'success');
                getAllApprovedLeads();
            }
        }
        catch(err){
            console.error(err);
            props.setSnackInfo('Something went wrong',err);
        }

    }

    return (
        <div>
            <div style={{ marginBottom: 20 }}>
                <h3 style={{ textAlign: 'center' }}>Design Quote Approval Dashboard</h3>
            </div>
            <div style={{ display: 'flex' }}>
                <FormControl style={{ width: '30%', marginTop: '0.4rem' }}>
                    <Autocomplete
                        multiple
                        // value={selectedExperienceCenter}
                        // onChange={handleMultipleExpData}
                        options={commonExpCenter}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select Exp-Center"
                                variant="outlined"
                            />
                        )}
                    />
                </FormControl>
            </div>

            <div style={{ marginTop: 20 }}>
                <TableContainer>
                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#333', color: '#fff' }}>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Sl No.</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Customer Name</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Project No.</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Lead No.</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Current Stage</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Sales Won Amount</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Assigned To</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Approval Reason</TableCell>
                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {approvalData?.length > 0 ?
                                approvalData?.map((row, i) => {
                                    return (
                                        <TableRow key={i + 1}>
                                            <TableCell component="th">{i + 1}</TableCell>
                                            <TableCell component="th" scope="row"> {row?.customerId?.name} </TableCell>
                                            <TableCell component="th" scope="row"> {row?.erpProjectNo ? row?.erpProjectNo : '-'} </TableCell>
                                            <TableCell component="th"> <Link to={`/project-logs/${row?._id}`} style={{ color: "#000", textDecoration: 'underline' }}>{row?.lead_no || "N/A"}</Link></TableCell>
                                            <TableCell component="th">{row?.currentStage ? row?.currentStage : 'NA'}</TableCell>
                                            <TableCell component="th">₹ {commaSeparateAmount(row?.staticSalesWonAmount) || 'NA'}</TableCell>
                                            <TableCell component="th">{row?.assignTo ? row?.assignTo?.name : 'NA'}</TableCell>
                                            <TableCell component="th">{row.designQuoteApproval?.reductionValueMoreThan20 ? 'Reduction is more than 20%' : row.designQuoteApproval?.reductionValueLessThan10More20 ?  'Reduction is more than 10% and less than or equal to 20%.' : '-' }</TableCell>
                                            <TableCell component="th" >
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <Button variant="contained" color="primary" style={{ marginRight: '10px', marginBottom: '3px' }} onClick={() => handleApprove(row)}> Approve </Button>
                                                    <Button variant="contained" color="secondary" onClick={() => handleReject(row)}>Reject</Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                                :
                                <TableRow>
                                    <TableCell colSpan={9} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <Dialog open={openDialog} onClose={()=> setOpenDialog(false)}>
                    <DialogTitle>Enter Remarks</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="remarks"
                            label="Remarks"
                            type="text"
                            fullWidth
                            style={{ width: 400 }}
                            value={remark}
                            onChange={(e)=> setRemark(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDialog(false)} color="secondary" variant="outlined">
                            Cancle
                        </Button>
                        <Button onClick={(e) => handleApprovalDesignQuote()} color="primary" variant="outlined">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(DesignQuoteApprovalPage)